import FormattedMessage from 'I18n/components/FormattedMessage';
import { ValueProps } from '../../constants/ValueProps';
import { isAppAuthSelector } from '../../selectors/AuthSelectors';
// @ts-expect-error jpg import
import Support from 'bender-url!../../img/valuePropsSection/247Support.jpg';
// @ts-expect-error jpg import
import tailoredOnboarding from 'bender-url!../../img/valuePropsSection/tailoredOnboarding.jpg';
// @ts-expect-error jpg import
import freeOnlineTraining from 'bender-url!../../img/valuePropsSection/freeOnlineTraining.jpg';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { CardGrid } from 'foundations-components/transitional/components/CardGrid';
import { Image } from 'foundations-components/transitional/components/Image';
import { PageSection, SectionHeader, SectionTitle } from 'pricing-pages-ui-components/semantic/PageSection';
import { useCallback } from 'react';
import { useAppSelector } from '../../reducers';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ValuePropsSection = () => {
  const isAppAuth = useAppSelector(isAppAuthSelector);
  const getValuePropImage = useCallback(valueProp => {
    switch (valueProp) {
      case '247Support':
        return Support;
      case 'tailoredOnboarding':
        return tailoredOnboarding;
      case 'freeOnlineTraining':
        return freeOnlineTraining;
      default:
        return null;
    }
  }, []);
  if (isAppAuth) return null;
  return /*#__PURE__*/_jsxs(PageSection, {
    children: [/*#__PURE__*/_jsx(SectionHeader, {
      children: /*#__PURE__*/_jsx(SectionTitle, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "valueProps.title"
        })
      })
    }), /*#__PURE__*/_jsx(CardGrid, {
      columns: 3,
      gutterSize: 32,
      children: ValueProps.map(valueProp => {
        return /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx(View, {
            borderRadius: "300",
            overflow: "hidden",
            children: /*#__PURE__*/_jsx(Image, {
              src: getValuePropImage(valueProp),
              inlineSize: "100%",
              objectFit: "contain",
              role: "img"
            })
          }), /*#__PURE__*/_jsx(Text, {
            as: "h3",
            typography: "heading-50",
            textAlign: "center",
            marginBlock: "400",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: `valueProps.props.${valueProp}.name`
            })
          }), /*#__PURE__*/_jsx(Text, {
            as: "div",
            textAlign: "center",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: `valueProps.props.${valueProp}.description`
            })
          })]
        }, valueProp);
      })
    })]
  });
};
export default ValuePropsSection;